export const wsRouteParamKey = "workspaceId";
export const wsRouteParamPlaceholder = `:${wsRouteParamKey}`;

export const routes = {
  top: (wsId: string) => `/workspace/${wsId}`,
  analysis: (wsId: string) => (id: string) => `/workspace/${wsId}/group/${id}`,
  dashboard: "/dashboard",
  admin: "/admin/",
  vocUpload: (wsId: string) => `/admin/workspace/${wsId}/data/upload`,
  vocUploadHistory: (wsId: string) => `/admin/workspace/${wsId}/data/upload-history`,
  execAnalysis: (wsId: string) => `/admin/workspace/${wsId}/data/processing`,
  attributeManagement: (wsId: string) => `/admin/workspace/${wsId}/attribute`,
  categoryUpload: (wsId: string) => `/admin/workspace/${wsId}/category/upload`,
  categoryDownload: (wsId: string) => `/admin/workspace/${wsId}/category/download`,
  displayGroup: (wsId: string) => `/admin/workspace/${wsId}/display-group`,
  displayGroupCreate: (wsId: string) => `/admin/workspace/${wsId}/display-group/create`,
  displayGroupEdit: (wsId: string) => (id: string) => `/admin/workspace/${wsId}/display-group/${id}/edit`,
  userList: (wsId: string) => `/admin/workspace/${wsId}/user`,
  userCreate: (wsId: string) => `/admin/workspace/${wsId}/user/create`,
  userEdit: (wsId: string) => (id: string) => `/admin/workspace/${wsId}/user/${id}/edit`,
  promptEdit: (wsId: string) => `/admin/workspace/${wsId}/prompt/edit`,
  tagList: (wsId: string) => `/admin/workspace/${wsId}/tag`,
  tagCreate: (wsId: string) => `/admin/workspace/${wsId}/tag/create`,
  tagEdit: (wsId: string) => (tagId: string) => `/admin/workspace/${wsId}/tag/${tagId}/edit`,
  tagAssignment: (wsId: string) => `/admin/workspace/${wsId}/tag-assignment`,
  workspaceList: "/admin/workspace",
  workspaceCreate: "/admin/workspace/create",
  workspaceEdit: (wsId: string) => `/admin/workspace/${wsId}/edit`,
  agent: (wsId: string) => `/workspace/${wsId}/agent`,
  agentThread: (wsId: string) => (threadId: string) => `/workspace/${wsId}/agent/${threadId}`,
  agentManagement: (wsId: string) => `/workspace/${wsId}/agent/management`,
  createCommand: (wsId: string) => `/workspace/${wsId}/agent/command/create`,
  editCommand: (wsId: string) => (commandId: string) => `/workspace/${wsId}/agent/command/${commandId}/edit`,
  createSubAgent: (wsId: string) => `/workspace/${wsId}/agent/sub-agent/create`,
  editSubAgent: (wsId: string) => (subAgentId: string) => `/workspace/${wsId}/agent/sub-agent/${subAgentId}/edit`,
};
